import React, { useEffect, useMemo, useRef, useState } from "react";
import images from "../../../assets/images";
import { useGlobalState } from "../../../MeetContext/MeetContext";
import { getInitials } from "../../../utils/webRTCHelper";
import { Tooltip } from "@mui/material";
import "./ParticipantsListView.scss";
import {
  RosterAttendeeType,
  useAttendeeStatus,
  useRosterState,
} from "amazon-chime-sdk-component-library-react";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import ParticipantCard from "../../ChimeMeeting/ChimeParticipantsList/ParticipantCard";

type Props = {};

interface ParticipantCardProps {
  participant: any;
  isHostParticipant?: boolean;
  isHandRaised: boolean;
}

const ParticipantsListMobileView = (props: Props) => {
  const { muteIcon, unMuteIcon } = images;
  const {
    attendeeId,
    hostId,
    isHost,
    muteAll,
    isHandRaised,
    participantsRef,
    participantList,
    setParticipantsList,
  } = useChimeMeeting();
  const { roster } = useRosterState();
  // const [attendees, setAttendees] = useState<any>([]);
  const [participantsCount, setParticipantsCount] = useState<number>(0);
  const [allAttendeeData, setAllAttendeeData] = useState<any>([]);

  useEffect(() => {
    if (roster && attendeeId) {
      const attendeeKeys = Object.keys(roster);
      let temp: any[] = [];
      let partTemp: any = {};
      const response = attendeeKeys.map((id: any) => {
        const attendeeData = roster[id] as RosterAttendeeType & {
          color: string;
        };
        partTemp[id] = {
          attendeeData,
          handRaised: participantsRef.current[id]?.handRaised ?? false,
        };
        console.log("attendee data inside the loop=====>", attendeeData);
        if (
          attendeeData?.chimeAttendeeId !== attendeeId &&
          !attendeeData?.externalUserId?.includes("aws:MediaPipeline") &&
          attendeeData?.externalUserId &&
          attendeeData?.chimeAttendeeId &&
          attendeeData?.name
        ) {
          temp.push({
            chimeAttendeeId: attendeeData?.chimeAttendeeId,
            externalUserId: attendeeData?.externalUserId,
            name: attendeeData?.name,
            handRaised:
              participantsRef.current[attendeeData?.chimeAttendeeId]
                ?.handRaised ?? false,
            color: attendeeData?.color || "#bdbdbd",
          });
        }
      });
      console.log("checking response", response);
      setParticipantsList(temp);
    }
  }, [roster]);

  // Separate the host and other participants
  const currentAttendeeData =
    roster &&
    Object.values(roster).find(
      (participant: any) => participant.chimeAttendeeId === attendeeId
    );

  const host: any =
    participantList &&
    participantList.find(
      (participant: any) => participant?.externalUserId === hostId
    );

  useEffect(() => {
    setAllAttendeeData(
      participantList &&
        participantList?.filter(
          (participant: any) => participant?.externalUserId !== hostId
        )
    );
    const count = participantList?.length + (currentAttendeeData ? 1 : 0);
    setParticipantsCount(count);
  }, [participantList]);

  const UserAvatarItem = ({
    participant,
    isHostParticipant = false,
    isHandRaised = false,
  }: ParticipantCardProps) => {
    const {
      ParticipantMuteIcon,
      ParticipantUnMuteIcon,
      ParticipantVideoOffIcon,
      ParticipantVideoOnIcon,
      ParticipantRaiseHand,
    } = images;
    const { muted, videoEnabled } = useAttendeeStatus(
      participant.chimeAttendeeId
    );
    const { muteParticipant, isHost } = useChimeMeeting();
    const icons = useMemo(() => {
      return {
        muteIcon: muted ? muteIcon : unMuteIcon,
        videoIcon: videoEnabled
          ? ParticipantVideoOnIcon
          : ParticipantVideoOffIcon,
        handRaisedIcon: isHandRaised ? ParticipantRaiseHand : "",
      };
    }, [muted, videoEnabled, isHandRaised]);
    return (
      <div
        style={{
          height: 76,
          width: 76,
          borderRadius: 76,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#ccf2f9",
          flexShrink: 0,
          position: "relative",
        }}
      >
        <div style={{ fontSize: 24, color: "black", fontWeight: "bold" }}>
          {getInitials(participant.name)}
        </div>
        <div
          style={{
            position: "absolute",
            top: 3,
            right: 0,
          }}
        >
          <img src={icons.handRaisedIcon} />
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 3,
            right: 0,
            background: "white",
            padding: 5,
            // height:26,
            // width:26,
            borderRadius: "50%",
          
            // boxShadow:
            //   "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.11)",
          }}
        >
          <img src={icons.muteIcon} />
        </div>
      </div>
    );
  };

  return (
    <div style={{ height: "120px", width: "100%", background: "white" }}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: 12,
          color: "black",
          padding: 5,
        }}
      >
        All Participants{" "}
        <span style={{ color: "#0a73ba" }}>{`${
          participantsCount ? participantsCount : 1
        }`}</span>
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 4,
          overflowX: "auto",
          margin: 8,
          whiteSpace: "nowrap",
        }}
      >
        {host && (
          <UserAvatarItem
            key={host?.chimeAttendeeId}
            participant={host}
            isHostParticipant={host?.externalUserId === hostId}
            isHandRaised={host?.handRaised}
          />
        )}
        {currentAttendeeData && (
          <UserAvatarItem
            key={currentAttendeeData?.chimeAttendeeId}
            participant={currentAttendeeData}
            isHostParticipant={isHost}
            isHandRaised={isHandRaised}
          />
        )}
        {allAttendeeData &&
          allAttendeeData?.map((user: any, index: number) => {
            return (
              <UserAvatarItem
                key={user?.chimeAttendeeId}
                participant={user}
                isHostParticipant={user?.externalUserId === hostId}
                isHandRaised={user?.handRaised}
              />
            );
          })}
      </div>
    </div>
  );
};

export default ParticipantsListMobileView;
